import { AppDispatch } from "@redux/app/store"
import { updateMapParamsState } from "@redux/features/mapParams/mapParamsSlice"
import { QueryClient } from "@tanstack/react-query"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction, useEffect } from "react"
import { RegularMapType, destroyInstance, getRegularMap, tryInitRegularMap } from "./regularMap"

type MapZoomLimits = {
	minZoom?: number
	maxZoom?: number
}

export default function useInitRegularMap(
	dispatch: AppDispatch,
	queryClient: QueryClient,
	setMap: Dispatch<SetStateAction<RegularMapType | undefined>>,
	t: TFunction<"translation", undefined>,
	map?: RegularMapType,
	divId?: string,
	zoomLimits?: MapZoomLimits
) {
	useEffect(() => {
		let temp: RegularMapType | undefined
		const init = async () => {
			if (map === undefined) {
				const newMap = await tryInitRegularMap(
					dispatch,
					queryClient,
					divId,
					undefined,
					t,
					zoomLimits
				)
				if (newMap !== undefined) {
					temp = newMap
				} else {
					temp = getRegularMap()
				}
				if (temp !== undefined) {
					setMap(temp)
				}
			}
		}
		init().catch(console.error)
		return () => {
			if (divId !== undefined && temp !== undefined) {
				dispatch(updateMapParamsState({ zoom: undefined }))
				destroyInstance(temp, divId)
			} else if (divId === undefined) {
				getRegularMap()?.clearLayers()
			}
		}
	}, [])

	useEffect(() => {
		map?.setTranslationFunc(t)
		getRegularMap()?.setTranslationFunc(t)
	}, [map, t])
}
